<template>
  <div class="home">
    <!-- Hero Section -->
    <v-container class="hero-section py-16">
      <v-row align="center" justify="center">
        <v-col cols="12" md="8" class="text-center">
          <h1 class="text-h2 mb-4">{{ $t('home.title') }}</h1>
          <p class="text-h5 text-grey-darken-1 mb-2">{{ $t('home.tagline') }}</p>
          <p class="text-body-1 mb-8">{{ $t('home.description') }}</p>
          
          <div class="d-flex flex-wrap justify-center gap-4 mb-8">
            <v-chip color="primary" label>
              <v-icon start>mdi-close-circle-outline</v-icon>
              {{ $t('home.features.noAds') }}
            </v-chip>
            <v-chip color="primary" label>
              <v-icon start>mdi-check-circle-outline</v-icon>
              {{ $t('home.features.simple') }}
            </v-chip>
            <v-chip color="primary" label>
              <v-icon start>mdi-shield-check</v-icon>
              {{ $t('home.features.safe') }}
            </v-chip>
          </div>

          <div class="cta-buttons">
            <v-btn
              color="primary"
              size="large"
              class="mr-4"
              @click="$router.push('/wall')"
            >
              {{ $t('home.cta.openWall') }}
            </v-btn>
            <v-btn
              color="primary"
              size="large"
              variant="outlined"
              @click="$router.push('/register')"
            >
              {{ $t('home.cta.createProfile') }}
            </v-btn>
          </div>

          <p class="text-subtitle-1 mt-4">
            {{ $t('home.pricing') }}
            <br /><span class="text-grey">{{ $t('home.pricingDetail') }}</span>
          </p>
        </v-col>
      </v-row>
    </v-container>

    <!-- Wall Preview Section -->
    <v-container class="wall-preview py-8">
      <v-row>
        <v-col cols="12" md="6">
          <v-card elevation="2" class="pa-4">
            <v-card-title class="text-h5">
              <v-icon color="primary" class="mr-2">mdi-post-outline</v-icon>
              {{ $t('wall.title') }}
            </v-card-title>
            <v-card-text>
              {{ $t('wall.subtitle') }}
            </v-card-text>
            <v-card-actions>
              <v-btn color="primary" @click="$router.push('/wall')">
                {{ $t('home.cta.goToWall') }}
                <v-icon end>mdi-arrow-right</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>

        <v-col cols="12" md="6">
          <v-card elevation="2" class="pa-4">
            <v-card-title class="text-h5">
              <v-icon color="primary" class="mr-2">mdi-account-group</v-icon>
              {{ $t('groups.title') }}
            </v-card-title>
            <v-card-text>
              {{ $t('groups.subtitle') }}
            </v-card-text>
            <v-card-actions>
              <v-btn color="primary" @click="$router.push('/groups')">
                {{ $t('groups.title') }}
                <v-icon end>mdi-arrow-right</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script setup>
</script>

<style scoped>
.hero-section {
  background: linear-gradient(135deg, #f5f5f5 0%, #e8f5e9 100%);
  min-height: 60vh;
}

.cta-buttons {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1rem;
}

.gap-4 {
  gap: 1rem;
}
</style>
